// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WqnA","colBig":"styles_colBig__1MoyB","colSmall":"styles_colSmall__yg5B5","shopifyNameWrapper":"styles_shopifyNameWrapper__3CZ8o"};